// Utils
import { formatPhone } from 'utils/formatString';

const replaceText = (text, value) => (value || value === 0 ? text.replace('{{TEXT}}', value) : text);
const splitText = (text) => text.split('{{DELETE}}');

const PAYMENT_DESKTOP_URL = '/customers/how-to-pay/popolnenie-scheta/#/ImmediatePayment/Mobile/';
const PAYMENT_MOBILE_URL = 'https://oplata.beeline.ru/mob/';

/** Определяем стартовый шаг отрисовки модального окна; */
// 1) Первое подключение номера в расчетном периоде:
// параметра freeAvailableChangeCount >= 0, и не вернул массив подключенных номеров favoriteNumbers

// 2) Изменение любимого номера. Платная замена:
// параметра freeAvailableChangeCount = 0, и вернул массив подключенных номеров favoriteNumbers

// 3) Изменение любимого номера. Платная замена. Недостаточно средств на счете:
// параметра freeAvailableChangeCount = 0, вернул массив подключенных номеров
// favoriteNumbers и вернулась сущность wantage

// 4) Изменение любимого номера. Бесплатная замена:
// параметра freeAvailableChangeCount > 0, и вернул массив подключенных номеров favoriteNumbers
export const getStep = (data) => {
  const {
    wantage,
    freeAvailableChangeCount,
    favoriteNumbers,
  } = data;

  let step = null;

  if (freeAvailableChangeCount > 0 && !favoriteNumbers.length) {
    step = 'connect';
  } else if (freeAvailableChangeCount === 0 && !favoriteNumbers.length) {
    step = 'reConnect';
  } else if (freeAvailableChangeCount === 0 && favoriteNumbers.length && wantage) {
    step = 'notAllowed';
  } else if (freeAvailableChangeCount === 0 && favoriteNumbers.length) {
    step = 'change';
  } else if (freeAvailableChangeCount > 0 && favoriteNumbers.length) {
    step = 'changeFree';
  }

  return step;
};

const getChangeModalBeforeText = (data) => {
  const { content: { reConnectModal }, freeChangeLimit, changePrice } = data;

  const pageSubTitle = reConnectModal.beforeContent.replace('{{FREE_CHANGE_LIMIT}}', freeChangeLimit);

  return pageSubTitle.replace('{{CHANGE_PRICE_AMOUNT}}', changePrice);
};

/** Собирает обьект с параметрами для модального окна нехватки денег при смене номера */
const getNotAllowedParams = (data) => {
  const {
    freeAvailableChangeCount,
    favoriteNumbers,
    changePrice,
    wantage,
    content,
  } = data;

  if (freeAvailableChangeCount && !favoriteNumbers) return;

  const {
    favoriteNumberText,
    changeNumberText,
    termChangeText,
    wantageText,
  } = content.notAllowedModal.paramsTexts;

  // Получаем любимый номер из массива в красивом формате
  const favoriteNumberValue = favoriteNumbers && favoriteNumbers.length && formatPhone(favoriteNumbers[0]);
  // Находим кол-во дней осталось до конца месяца;
  const date = new Date();
  const dayInMonth = new Date(date.getFullYear(), date.getDate(), 0).getDate();
  const dayLeft = dayInMonth - date.getDate();

  const paramsArray = [{
    value: favoriteNumberValue,
    description: favoriteNumberText,
  }, {
    value: `${changePrice} руб.`,
    description: changeNumberText,
  }, {
    value: `${dayLeft} дней`,
    description: termChangeText,
  }];

  if (wantage) {
    paramsArray.push({
      value: `${wantage} руб.`,
      description: wantageText,
    });
  }

  return paramsArray;
};

export const getFavoriteNumberState = (data) => {
  const {
    content, favoriteNumbers, changePrice, ctn, wantage,
  } = data;
  const favoriteNumberValue = favoriteNumbers && favoriteNumbers.length ? formatPhone(favoriteNumbers[0]) : null;

  const beautyDeleteText = replaceText(content.deleteModal.contentText, favoriteNumberValue);
  const beautyConfirmText = replaceText(content.confirmModal.contentText, favoriteNumberValue);
  const beautySuccessText = replaceText(content.successModal.contentText, favoriteNumberValue);
  const beautyDelSuccessText = replaceText(content.delSuccessModal.contentText, favoriteNumberValue);
  const beautyChangeButtonText = changePrice ? replaceText(content.changeModal.buttonText, changePrice) : 'Сменить';
  const beautyBeforeText = getChangeModalBeforeText(data);
  const splitDeleteText = splitText(content.changeModal.deleteText);
  const splitChangeDeleteText = favoriteNumberValue ? splitText(content.changeFreeModal.deleteText) : null;

  // Собираем ссылку для пополнения счета при нехватки денег на балансе;
  const paymentUrl = /mobile/i.test(navigator.userAgent) ? PAYMENT_MOBILE_URL : PAYMENT_DESKTOP_URL;
  let fullPaymentUrl = `${paymentUrl}?ctn=${ctn}`;
  if (wantage) {
    fullPaymentUrl = `${fullPaymentUrl}&sum=${wantage}`;
  }

  return {
    ...data,
    favoriteNumber: favoriteNumberValue,
    step: getStep(data),
    modalData: {
      reConnectModal: {
        ...content.reConnectModal,
        beforeContent: beautyBeforeText,
      },
      errorModal: content.errorModal,
      changeFreeModal: {
        ...content.changeFreeModal,
        deleteText: splitChangeDeleteText,
      },
      connectModal: content.connectModal,
      notAllowedModal: {
        ...content.notAllowedModal,
        params: getNotAllowedParams(data),
        paymentUrl: fullPaymentUrl,
      },
      deleteModal: {
        ...content.deleteModal,
        contentText: beautyDeleteText,
      },
      confirmModal: {
        ...content.confirmModal,
        contentText: beautyConfirmText,
      },
      changeModal: {
        ...content.changeModal,
        buttonText: beautyChangeButtonText,
        deleteText: splitDeleteText,
      },
      successModal: {
        ...content.successModal,
        contentText: beautySuccessText,
      },
      delSuccessModal: {
        ...content.delSuccessModal,
        contentText: beautyDelSuccessText,
      },
    },
  };
};
